import { create } from "zustand";
import { combine } from "zustand/middleware";

import { updateUrlParams } from "./utils";

const getCurrentYear = () => new Date().getFullYear();

const getDashboardUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const yearParam = searchParams.get("year");
  return {
    includePractice: searchParams.get("includePractice") === "true",
    filter: (searchParams.get("filter") as "pitching" | "hitting") || "hitting",
    selectedYear: yearParam ? parseInt(yearParam, 10) : getCurrentYear(),
  };
};

export const useDashboardStore = create(
  combine(
    {
      ...getDashboardUrlParams(),
    },
    (set) => ({
      setIncludePractice: (includePractice: boolean) => {
        updateUrlParams({ includePractice: includePractice.toString() });
        set({ includePractice });
      },
      setFilter: (filter: "pitching" | "hitting") => {
        updateUrlParams({ filter });
        set({ filter });
      },
      setSelectedYear: (year: number) => {
        updateUrlParams({ year: year.toString() });
        set({ selectedYear: year });
      },
    }),
  ),
);
